import React from "react";
import CroppedText from "sulu-admin-bundle/components/CroppedText";
import Button from "sulu-admin-bundle/components/Button";
import shirt from "../../../svgs/Shirt";
import "./header.scss";
import Loader from "sulu-admin-bundle/components/Loader";
import Icon from "sulu-admin-bundle/components/Icon";
import multiSelectionStyles from "../CustomStyle.scss";
import SingleSelect from "sulu-admin-bundle/components/SingleSelect";
import { toJS } from "mobx";
import MultiSelect from "sulu-admin-bundle/components/MultiSelect";

const Option = MultiSelect.Option;

const headerColums = (props) => {
    const jersey = props?.t("sulu_admin.match.jersey");
    const name = props?.t("sulu_admin.match.first.lastname");
    const captain = props?.t("sulu_admin.match.captain");
    const goalkeeper = props?.t("sulu_admin.match.goalkeeper");
    const substitute = props?.t("sulu_admin.match.substitute.gk");

    const hC = (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1fr 2fr repeat(4, 1fr)",
                width: "80%",
            }}
        >
            <div> {jersey}*</div>
            <div> {name}</div>
            <div> Pass-Nr.</div>
            <div> Status</div>
            <div> {captain}*</div>
            <div> Position</div>
        </div>
    );

    return hC;
};

const footer = (
    noOfSelectedPlayer,
    minPlayers,
    maxPlayers,
    dataPath,
    hideLegend
) => {
    if (hideLegend) {
        return;
    }

    const isMatchPlayers = dataPath !== "/coreSquad";

    const warningMessage =
        noOfSelectedPlayer < minPlayers
            ? `Du musst noch ${
                  minPlayers - noOfSelectedPlayer
              } Spieler hinzufügen.`
            : isMatchPlayers && noOfSelectedPlayer > maxPlayers
            ? `Du hast die maximale Spieleranzahl um ${
                  noOfSelectedPlayer - maxPlayers
              } überschritten.`
            : "";

    const numberColor = {
        color:
            noOfSelectedPlayer < minPlayers
                ? "red"
                : isMatchPlayers && noOfSelectedPlayer > maxPlayers
                ? "red"
                : "green",
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: "#E5E5E5",
                    fontSize: "16px",
                    padding: "10px 20px",
                    border: "1px solid #DDDDDD",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                Spieler gesamt {noOfSelectedPlayer}
                <strong style={numberColor}>
                    ({minPlayers}
                    {isMatchPlayers && ` - ${maxPlayers}`})
                </strong>
                {warningMessage && (
                    <div
                        style={{
                            color: "red",
                            fontSize: "12px",
                        }}
                    >
                        {warningMessage}
                    </div>
                )}
            </div>

            <div>
                <div style={{ margin: "10px", marginLeft: "100px" }}>
                    <p>
                        {shirt({ fill: "black" })} Stammspieler*in - kann nicht
                        in unteren Teams eingesetzt werden.
                    </p>
                    <p>
                        {shirt({ fill: "white", stroke: "black" })} Spieler*in
                        kann noch x Spiele für das Team absolvieren bis er/sie
                        festgespielt ist. Spieler*in ist noch in unteren Teams
                        spielberechtigt.
                    </p>
                    {/* <p> { shirt({fill: 'lightgrey', stroke: 'black'}) } Spieler*in ist festgespielt. Spieler*in kann nicht mehr in unteren Teams eingesetzt werden.</p> */}

                    <p>
                        <span>C</span> SpielerIn ist KapitänIn
                    </p>
                </div>
            </div>
        </>
    );
};

const inputNumb = (
    item,
    displayProperty,
    itemClickHandler,
    aditionalParams = ""
) => {
    const number = item[displayProperty];

    return (
        <input
            style={{
                boxSizing: "border-box",
                width: "27px",
                textAlign: "center",
                height: "27px",
                left: "0px",
                right: "0px",
                top: "0px",
                background: "#FFFFFF",
                border:
                    !number || number == "/"
                        ? "1px solid red"
                        : "1px solid #ccc",
                borderRadius: "3px",
            }}
            type="number"
            inputMode="numeric"
            onChange={(ev) => {
                itemClickHandler(
                    ev.currentTarget.value,
                    item.id,
                    displayProperty
                );
            }}
            value={number && number !== "/" ? number : ""}
        ></input>
    );
};

const positionDropdown = (
    item,
    displayProperty,
    itemClickHandler,
    positions
) => {
    let playerPositions = toJS(positions);

    const selectedValues = item[displayProperty]?.map((position) => {
        return position.id;
    });

    return (
        <div
            style={{
                width: "8rem",
            }}
        >
            <MultiSelect
                displayValue={"Choose position"}
                name="positions"
                values={selectedValues}
                onChange={(values) => {
                    itemClickHandler(values, item.id, displayProperty);
                }}
            >
                {playerPositions.map((position) => (
                    <Option key={position.id} value={position.id}>
                        {position.name}
                    </Option>
                ))}
            </MultiSelect>
        </div>
    );
};

const columnCustom = (
    item,
    itemColumnClass,
    itemClickHandler,
    displayProperty,
    columns,
    inputNumb,
    aditionalParams = {},
    data,
    handlerClick,
    index,
    positions
) => {
    // item.id is really a row id
    const loadingColumns = aditionalParams.loadingMatchesTeams.filter(
        (cur) => cur.id === item.id
    );

    const isLoading = Boolean(
        loadingColumns.some((column) => column?.prop === displayProperty) &&
            aditionalParams.isLoading
    );
    const allowedProperties = [
        "shirtNumber",
        "isInCoreSquad",
        "isCaptain",
        "lastName",
        "passportNumber",
        "positions",
    ];

    const renderLoader = (
        <div
            style={{
                width: 15,
                display: "inline-block",
                verticalAlign: "middle",
            }}
        >
            <Loader size={15} />
        </div>
    );

    const fill = null;
    const renderContent = () => {
        switch (displayProperty) {
            case "shirtNumber":
                return isLoading
                    ? renderLoader
                    : inputNumb(item, displayProperty, itemClickHandler, {
                          disabled: aditionalParams.isLoading,
                      });
            case "isInCoreSquad":
                return shirt({ isCore: item[displayProperty], fill });
            case "lastName":
                return `${item.lastName} , ${item.firstName}`;
            case "isCaptain":
                return isLoading ? (
                    renderLoader
                ) : (
                    <input
                        type="checkbox"
                        disabled={aditionalParams.isLoading}
                        onChange={(ev) =>
                            itemClickHandler(
                                ev.currentTarget.checked,
                                item.id,
                                displayProperty
                            )
                        }
                        checked={!!item[displayProperty]}
                    />
                );
            case "positions":
                return positionDropdown(
                    item,
                    displayProperty,
                    itemClickHandler,
                    positions
                );
            default:
                if (item[displayProperty]) {
                    return item.passportId ? (
                        <div onClick={() => handlerClick(item)}>
                            <Button skin="link">{item[displayProperty]}</Button>
                        </div>
                    ) : (
                        <div style={{ color: "red" }}>Invalid Pass.</div>
                    );
                }
                return null;
        }
    };

    return allowedProperties.includes(displayProperty) ? (
        <div
            className={`${itemColumnClass}`}
            key={`${displayProperty}-${item.id}`}
            style={{
                paddingLeft: "0",
                display: "flex",
                alignItems: "center",
                width: "fit-content",
            }}
        >
            {renderContent()}
        </div>
    ) : null;
};

export { headerColums as hackHeader, inputNumb, columnCustom, footer };
